/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrgIdsListRequestSpec { 
    /**
     * List of Org Ids to be processed
     */
    org_ids: Array<string>;
}

